import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, createObject, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import DrawyerNote from "../../Notes/DrawyerNote";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";

export const OverViewNotesContact: React.FC<any> = React.memo((props) => {
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getNotesPermission;
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const params = useParams();
  const [open, setOpen] = React.useState(false);
  const [notesData, setNotesData] = useState<any>([])
  const [resetLoad, setResetLoad] = useState(false)
  const id = params?.id;
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [formComponent, setFormComponent] = useState<any>()
  const isMobile = IsSmallScreen();
  const resetTrigger = useSelector((state: any) => state.components?.contactNotesGrid?.resetTrigger);
  const columns: IColumns[] = [
    {
      header: "Notes",
      fieldName: "content",
      tooltip: true,
      type: 'default'
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",

      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
  ];
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      const form: any = <DrawyerNote
        id={id}
        control={control}
        register={register}
        noteId={row.id}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}

      />
      setFormComponent(form)
      setTimeout(() => {
        setOpen(true)
      }, 10);
    }
  }
  useEffect(() => {
    const getNotes = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI('notes/lead', Method.GET, null, id);
        if (response.data) {
          setNotesData(response?.data || []);
        }
      }


      catch (e) {

      }
    }
    if (id) {
      getNotes();
    }
  }, [resetTrigger])
  useEffect(() => {

    const getNotes = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI('notes/lead', Method.GET, null, id);
        if (response.data) {
          setNotesData(response?.data || []);
        }
      }
      catch (e) {
      }
    }
    if (id) {
      getNotes();
    }
  }, [resetLoad])
  const handleData = async (data: any) => {
    try {
      if (data?.content && id && !data?.noteId) {
        dispatch(storeDataComponent('noteSubmit', { loading: true }));
        setResetLoad(true)
        const response = await createObject('notes', { content: data?.content, leadId: id })
        if (response && response?.message) {
          dispatch(resetDataComponent('contactNotesGrid'));
          reset()
          showMessage(response.message, response.success === true ? 'success' : 'error')
        } else if (response?.id) {
          dispatch(resetDataComponent('contactNotesGrid'));
          showMessage('Notes Created Successfully', 'success')
        }
      }
      else {
        dispatch(storeDataComponent('noteSubmit', { loading: true }));
        const response = await callAPI('notes', Method.PUT, { content: data?.content, leadId: id }, data?.noteId)
        setResetLoad(true)
        if (response && response?.message) {
          dispatch(resetDataComponent('contactNotesGrid'));
          dispatch(storeDataComponent('noteSubmit', { loading: false }));
          showMessage(response.message, response.success === true ? 'success' : 'error')
        } else if (response?.id) {
          dispatch(resetDataComponent('contactNotesGrid'));
          showMessage('Notes Updated Successfully', 'success')
        }
      }
    }
    catch (e) { }
    finally {
      dispatch(updateDataComponent('noteSubmit', { loading: false }));
    }
  }

  const handleNoteClick = () => {
    const form: any = <DrawyerNote
      id={id}
      control={control}
      register={register}
      reset={reset}
      setValue={setValue}
      onCancel={() => { reset(); setOpen(false) }}

    />
    setFormComponent(form)
    setTimeout(() => {
      setOpen(true)
    }, 10);
  }

  return (
    <Grid>
      <Grid container spacing={2} sx={{ p: 0, borderRadius: 5 }}>
        {view ? <Grid item xs={12}>
          <WSDataGrid
            id="contactNotesGrid"
            title="Notes"
            columns={columns}
            data={notesData}
            addButton={{ label: 'New', color: 'secondary', }}
            onAddButtonClick={handleNoteClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />

        </Grid>
          : <PermissionDenied />}
        <Grid item xs={12}>
          {formComponent && <SwipeableDrawerForm isMobile={isMobile} anchor="right" title={'Notes'}
            openForm={open}
            formComponent={<form onSubmit={handleSubmit(handleData)}>
              {formComponent}
            </form>}
            onClose={() => { reset(); setOpen(false); setFormComponent(null) }}

          />}
        </Grid>
      </Grid>
    </Grid>
  );
});
